import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function AVisionForTheCarolinas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="a-vision-for-the-carolinas" className="dark bg-background text-foreground relative flex min-h-[85vh] items-center justify-center overflow-hidden py-20">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/40 z-10" /> {}
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1563866/img/wood_paneled_office_library.png)] bg-cover bg-center bg-no-repeat" />
      </div>

      {}
      <div className="container relative z-20 px-4 md:px-6">
        <div ref={ref} className={`mx-auto max-w-3xl transform transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <div className="bg-[hsl(210_20%_98%)]/90 text-[hsl(222_47%_11%)] shadow-2xl backdrop-blur-sm rounded-sm p-8 md:p-12 lg:p-16 text-center border border-[hsl(222_47%_11%)]/10">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium mb-6 tracking-tight leading-tight">
              A Vision for the Carolinas
            </h1>
            
            <div className="w-16 h-1 bg-[hsl(43_48%_59%)] mx-auto mb-8" />

            <p className="text-lg md:text-xl leading-relaxed text-[hsl(222_47%_11%)]/80 mb-8 font-sans">
              Cyradon Capital was founded on a simple yet powerful belief: that true wealth management requires more than just investment advice—it demands a holistic architecture of tax strategy, estate planning, and personalized care. Rooted in the heart of Charlotte, we saw a need for a firm that understands the unique landscape of the Carolinas, serving the wealth building and asset protection and business owners who drive our region's growth.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" className="bg-[hsl(222_47%_11%)] text-[hsl(210_20%_98%)] hover:bg-[hsl(222_47%_11%)]/90 border-none">
                <Link to="/WealthArchitecturePage">The Philosophy</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-[hsl(222_47%_11%)] text-[hsl(222_47%_11%)] hover:bg-[hsl(222_47%_11%)]/5 bg-transparent">
                <Link to="/SecureYourLegacyPage">
                  Start the Conversation <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}